import React, { useState } from 'react';
import { Container } from 'rsuite';
import { useParams } from 'react-router-dom';
import Sidebar from './nav/sidenav';
import Page from './page/page';
import Brief from './briefs/brief';

export default function Main() {
  const [expand, setExpand] = useState(true);
  const [selectedTab, setSelectedTab] = useState('Dashboard');

  const { panel } = useParams();

  return (
    <div className="main">
      <Container>
        <Sidebar expand={expand} setExpand={setExpand} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
        <Container className="main-content">
          <Page expand={expand} setExpand={setExpand} pageName={selectedTab}>
            {
              panel === "main" ?
                <Brief /> :
                null
            }
          </Page>
        </Container>
      </Container>
    </div>
  );
}